// ─────────────────────────────────────────────────────────────
// Add this to your web app's main.jsx or App.jsx.
// When running inside the React Native WebView shell, RN will
// call window.__registerPushToken() with the Expo push token.
// We then send it to your backend just like we do with FCM.
// ─────────────────────────────────────────────────────────────

export function setupNativePushBridge() {
  // Expose a function RN can call via injectJavaScript
  window.__registerPushToken = async (expoPushToken) => {
    if (!expoPushToken) return;
    const authToken = localStorage.getItem("user_token");
    if (!authToken) return; // user not logged in yet — RN will retry after auth_token message

    try {
      await fetch(`${import.meta.env.VITE_API_URL}/api/mtrade/notifications/register-token`, {
        method:  "POST",
        headers: {
          "Content-Type":  "application/json",
          "Authorization": `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          token:    expoPushToken,
          platform: "expo",         // backend can store this to use Expo Push API
        }),
      });
      console.log("[Bridge] Expo push token registered");
    } catch (err) {
      console.warn("[Bridge] Failed to register push token:", err.message);
    }
  };

  // Also expose a logout signal so RN can clear its stored token
  window.__signalLogout = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: "logout" }));
    }
  };
}
